const AIRPORTS = [
  // National Airports (NAC)
  "Jacksons International Airport",
  "Nadzab Tomodachi International Airport",
  "Kagamuga Airport (Mt Hagen)",
  "Tokua Airport (Rabaul)",
  "Madang Airport",
  "Boram Airport (Wewak)",
  "Gurney Airport",
  "Hoskins Airport (Kimbe)",
  "Goroka Airport",
  "Kavieng Airport",
  "Buka Airport",
  "Momote Airport",
  "Vanimo Airport",
  "Tari Airport",
  "Mendi Airport",
  "Chimbu Airport",
  "Wapenamanda Airport",
  "Kerema Airport",
  "Kiunga Airport",
  "Daru Airport",
  "Girua Airport",
  "Aropa Airport (Kieta)",
  // Licensed / Commercial Aerodromes
  "Awaba Airport",
  "Baimuru Airport",
  "Balimo Airport",
  "Bosset Airport",
  "Bulolo Airport",
  "Efogi Airport",
  "Fane Airport",
  "Itokama Airport",
  "Kagi Airport",
  "Kamusi Airport",
  "Kikori Airport",
  "Kokoda Airport",
  "Lihir Island Airport (Kunaye)",
  "Lake Murray Airport",
  "Losuia Airport (Kiriwina)",
  "Manari Airport",
  "Milei Airport",
  "Misima Airport",
  "Moro Airport",
  "Nomad River Airport",
  "Obo Airport",
  "Ononge Airport",
  "Sasereme Airport",
  "Suki Airport",
  "Tabubil Airport",
  "Tapini Airport",
  "Tufi Airport",
  "Wabo Airport",
  "Wanigela Airport",
  "Wipim Airport",
  "Woitape Airport",
  // Other Licensed Aerodromes
  "Abau Airport",
  "Agaun Airport",
  "Aiambak Airport",
  "Aiome Airport",
  "Aiyura Airport",
  "Bensbach Airport",
  "Biangabip Airport",
  "Cape Gloucester Airport",
  "Finschhafen Airport",
  "Gasmata Airport",
  "Gusap Airport",
  "Haelogo Airport",
  "Ihu Airport",
  "Jacquinot Bay Airport",
  "Kandrian Airport",
  "Karimui Airport",
  "Manguna Airport",
  "Mok Airport",
  "Nissan Island Airport",
  "Saidor Airport",
  "Salamo Airport",
  "Samberigi Airport",
  "Sangapi Airport",
  "Tadji Airport (Aitape)",
  "Talasea Airport",
  "Vivigani Airfield",
  // Rural / Community Airstrips
  "Kairik Airstrip (Porgera)",
  "Kompiam Airstrip",
  "Kandep Airstrip",
  "Maramuni Airstrip",
  "Komo Airfield",
  "Fugwa (Koroba) Airstrip",
  "Margarima Airstrip",
  "Wau Airstrip",
  "Menyamya Airstrip",
  "Aseki Airstrip",
  "Kabwum Airstrip",
  "Wasu Airstrip",
  "Garaina Airstrip",
  "Telefomin Airstrip",
  "Oksapmin Airstrip",
  "Green River Airstrip",
  "Ambunti Airstrip",
  "Hayfield (Maprik) Airstrip",
  "Angoram Airstrip",
  "Karawari (Amboin) Airstrip",
  "Simbai Airstrip",
  "Teptep Airstrip",
  "Wonenara Airstrip",
  "Marawaka Airstrip",
  "Morehead Airstrip",
  "Olsobip Airstrip",
  "Ningerum Airstrip",
];

export default AIRPORTS;
